import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'

const Timer = ({action, initialTime = 60 }) => {

 const [timeLeft,setTimeLeft] = useState(initialTime)   

 useEffect(()=>{
   if(timeLeft===0) {
    action()
    return;
}

   const intervalId= setInterval(()=>{
    setTimeLeft(timeLeft-1)

   },1000)

   return ()=>clearInterval(intervalId)
 },[timeLeft])

 const minutes = Math.floor(timeLeft/60);
 const seconds = timeLeft%60;
  return (
    <span style={{ fontWeight: 500 }}>
        Resend OTP in {minutes.toString().padStart(2,"0")}:{seconds.toString().padStart(2,"0")}
    </span>
  )
}

export default Timer